import { CountrySelectionBox } from '../../country-selection-box.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer } from '../types'

const renderCountryField: FieldRenderer = ({ field, ctx, t }) => {
    const key = field.key
    return (
        <CountrySelectionBox
            key={key}
            label={t(field.label)}
            countryList={ctx.countryList ?? []}
            value={ctx.form[key] as string}
            onChange={code => ctx.setForm((prev: Record<string, unknown>) => ({ ...prev, [key]: code }))}
            disabled={ctx.formDisabled || ctx.geoLoading}
            getDisplayName={ctx.getCountryDisplayName}
            inputTestId={getFieldTestId(ctx, key, 'input')}
            data-testid={getFieldTestId(ctx, key, 'country-selection-box')}
        />
    )
}

renderCountryField.areCtxEqual = (a, b) =>
    a.countryList === b.countryList && a.geoLoading === b.geoLoading && a.getCountryDisplayName === b.getCountryDisplayName

export default renderCountryField
